import React from 'react';
import Price from '@synergycms_core/components/generic/Price';
import RichText from '@synergycms_core/components/generic/RichText';

import { Loading } from '@synergycms_core/components/functional/Loading';

export const EquivalentPrice = props =>
  ((props.hotelCurrencyCode !== props.currentCurrencyCode) || (props.altCurrency)) && (
    <div>
      <RichText
        text={'_%importe equivalente a%_ '}
        innerStyle={['roboto11SoftGray400', 'accesabilityGray']}
        ucFirst={true}
        translate={true}
      />{' '}
      <Price innerStyle={['summaryPriceExtraSmall']} amount={props.totalPrice} forceHotelCurrency={true} altCurrency={props.altCurrency} />
    </div>
  );

export const OldPrice = props =>
  props.discountPercent >= 5 && (
    <Price innerStyle={['summaryPriceLittle']} amount={props.amount + props.discountAmount} ariaHidden={true}/>
  );

export const TaxIncluded = props =>
  props.showTaxes && (
    <RichText text={'_%impuestos incluidos%_'} innerStyle={['roboto11SoftGray400', 'accesabilityGray']} ucFirst={true} translate={true} />
  );

export const LoadingFragment = () => (
  <React.Fragment>
    <Loading
      richText={{
        innerStyle: ['descriptionText'],
        ucFirst: true,
        text: '_%estamos procesando su reserva%_',
        translate: true
      }}
    />
  </React.Fragment>
);

export const LoadingConfirmation = () => (
  <React.Fragment>
    <Loading
      richText={{
        innerStyle: ['descriptionText'],
        ucFirst: true,
        text: '_%estamos confirmando su reserva%_',
        translate: true
      }}
    />
  </React.Fragment>
);

export class EPGContainer extends React.Component {
  static displayName = 'EPGContainer';

  render() {
    const { tpvEnabled, epgCashierContainer, epgPrepayToken, payFormSelected, reservationPaid, UserLoggedST } = this.props;
    return (
      (!UserLoggedST || (UserLoggedST &&  (payFormSelected === 'apple' || payFormSelected === 'bizum'))) && tpvEnabled === 'EPG' && !reservationPaid && (
        <span>
          <div
            id={epgCashierContainer}
            // Els estils son en linia per aconseguir ser mes restrictius que els del HTML
            style={(payFormSelected === 'op' || payFormSelected === 'apple' || payFormSelected === 'bizum') && epgPrepayToken === false ? { display: 'block' } : { display: 'none' }}
          />
        </span>
      )
    );
  }
}

export const NemuruCheckout = (props) => {
  //const {nemuru,reservation} = props;
  
  //const [paymentConditions, setPaymentConditions] = React.useState(null);

  //useEffect(() => {
  //  const initializeNemuru = async () => {
  //    await nemuru.init();
  //    return nemuru.paymentConditions(reservation);
  //  };
  //  initializeNemuru().then(r => {
  //    setPaymentConditions(r || null);
  //  });
  //}, [nemuru,reservation]);

  return (
    <>
      {/*paymentConditions && paymentConditions.length > 0 ? (
        <Options 
          onSelectChange={(value) => {
            setSelected(value);
          }}
        >
          {Object.values(paymentConditions).map((condition, index) => {
            if(!condition.conditions) return null;
            
            console.log('condition', condition);
            let conditions = condition.conditions;
            
            return (
              <div key={index} >
                <p>mesos: {conditions.term}</p>
                <p>precio: {conditions.instalmentTotalAmount && conditions.instalmentTotalAmount.value}</p>
                <p>total interesos: {conditions.totalInterestAmount && conditions.totalInterestAmount.value}</p>
                <p>total: {conditions.totalAmount && conditions.totalAmount.value}</p>
                <br/>
              </div>
            )
          })}
        </Options>
      ) : (
        <h1>LOADING CONDITIONS</h1>
      )*/}
      <div id="nemuru-bnpl"></div>
    </>
  );
};
